import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "uploadWrap"
};
const _hoisted_2 = {
  key: 0,
  class: "uploadList"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 2,
  class: "uploadText"
};
const _hoisted_7 = {
  class: "uploadButton-normal"
};
const _hoisted_8 = ["multiple", "accept"];
const _hoisted_9 = {
  key: 3,
  class: "uploadText"
};
const _hoisted_10 = {
  class: "uploadButton-normal"
};
const _hoisted_11 = ["multiple", "accept"];
const _hoisted_12 = {
  key: 1,
  class: "uploadList3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_button = _resolveComponent("el-button");
  const _component_CircleCheck = _resolveComponent("CircleCheck");
  const _component_Close = _resolveComponent("Close");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.styletype === 2 ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createVNode(_component_el_icon, {
      class: "delete",
      onClick: $event => $options.deleteHandle(item)
    }, {
      default: _withCtx(() => [_createVNode(_component_Delete)]),
      _: 2
    }, 1032, ["onClick"]), _cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "shadow"
    }, null, -1)), _createElementVNode("img", {
      src: item.http || item.fileUrl,
      alt: ""
    }, null, 8, _hoisted_3)]);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["uploadInfo", `type${$props.styletype}`])
  }, [$props.styletype === 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "uploadImage",
    style: _normalizeStyle({
      width: `${$props.width}px`,
      height: `${$props.height}px`
    })
  }, [$data.imgurl !== '' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.imgurl,
    alt: ""
  }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $data.upImg,
    alt: ""
  }, null, 8, _hoisted_5)), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "shadow"
  }, null, -1)), _createVNode(_component_el_icon, {
    class: "delete",
    onClick: _cache[0] || (_cache[0] = $event => $options.deleteHandle($data.fileList[0]))
  }, {
    default: _withCtx(() => [_createVNode(_component_Delete)]),
    _: 1
  })], 4)) : _createCommentVNode("", true), $props.styletype === 2 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "uploadImage",
    style: _normalizeStyle({
      width: `${$props.width}px`,
      height: `${$props.height}px`
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Plus)]),
    _: 1
  })], 4)) : _createCommentVNode("", true), $props.styletype === 1 || $props.styletype === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_withDirectives(_createElementVNode("p", null, "格式：" + _toDisplayString($data.accept), 513), [[_vShow, $data.accept !== '']]), _withDirectives(_createElementVNode("p", null, "大小：不超过" + _toDisplayString($data.imgsize) + "MB", 513), [[_vShow, $data.imgsize > 0]]), _withDirectives(_createElementVNode("p", null, "尺寸：" + _toDisplayString($data.imgWH), 513), [[_vShow, $data.imgWH !== '']]), _withDirectives(_createElementVNode("p", null, _toDisplayString($data.imglimit), 513), [[_vShow, $data.imglimit !== '']]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, null, {
    default: _withCtx(() => [_cache[5] || (_cache[5] = _createTextVNode("上传 ")), _createElementVNode("input", {
      class: "uploadInput",
      ref: "fileInput",
      type: "file",
      multiple: $data.multiple,
      accept: $data.accept,
      onChange: _cache[1] || (_cache[1] = (...args) => $options.fileChangeHandle && $options.fileChangeHandle(...args))
    }, null, 40, _hoisted_8)]),
    _: 1
  })])])) : _createCommentVNode("", true), $props.styletype === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, null, {
    default: _withCtx(() => [_createTextVNode("上传" + _toDisplayString($props.name) + " ", 1), _createElementVNode("input", {
      class: "uploadInput",
      ref: "fileInput",
      type: "file",
      multiple: $data.multiple,
      accept: $data.accept,
      onChange: _cache[2] || (_cache[2] = (...args) => $options.fileChangeHandle && $options.fileChangeHandle(...args))
    }, null, 40, _hoisted_11)]),
    _: 1
  })])])) : _createCommentVNode("", true)], 2), $props.styletype === 3 ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createVNode(_component_el_icon, {
      class: "check"
    }, {
      default: _withCtx(() => [_createVNode(_component_CircleCheck)]),
      _: 1
    }), _createVNode(_component_el_icon, {
      class: "delete",
      onClick: $event => $options.deleteHandle(item)
    }, {
      default: _withCtx(() => [_createVNode(_component_Close)]),
      _: 2
    }, 1032, ["onClick"])]);
  }), 128))])) : _createCommentVNode("", true)]);
}